import React from "react";
import {
  Edit,
  TextInput,
  ReferenceInput,
  AutocompleteInput,
  SimpleForm,
  FormDataConsumer,
  email,
  required,
} from "react-admin";
import FormContainer from "../common/FormContainer";
import { PasswordInput } from "../common/PasswordInput";
import useUpdateWithValidation from "../common/useUpdateWithValidation";

import RoleSelectInput from "./RoleSelectInput";

const AccountEdit = () => {
  const save = useUpdateWithValidation("Account");

  return (
    <Edit>
      <SimpleForm onSubmit={save}>
        <FormContainer>
          <TextInput
            source="emailAddress"
            validate={[required(), email()]}
            fullWidth
          />
          <PasswordInput
            source="password"
            helperText="Leer lassen, um bestendes Passwort zu behalten"
            fullWidth
          />
          <RoleSelectInput source="role" validate={required()} />
          <FormDataConsumer>
            {({ formData, ...rest }) =>
              formData.role === "CustomerAdministrator" && (
                <ReferenceInput
                  source="customerId"
                  reference="Customer"
                  sort={{ field: "name", order: "ASC" }}
                  filterToQuery={(searchText: any) => ({
                    q: searchText,
                  })}
                  {...rest}
                >
                  <AutocompleteInput optionText="name" fullWidth validate={required()} />
                </ReferenceInput>
              )
            }
          </FormDataConsumer>
        </FormContainer>
      </SimpleForm>
    </Edit>
  );
};

export default AccountEdit;
